import React, { useEffect } from 'react';
import { makeStyles } from "@material-ui/core/styles";

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';


const TermsAndConditionsDialog = props => {
    const { open, setOpen } = props;
    const [terms, setTerms] = React.useState(null);

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        new Promise((resolve, reject) => {
            resolve();
            const url = '/approval/terms-and-conditions';
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(result => {
                    setTerms(result.setting);
                })
        });
    }, [null]);

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} maxWidth="lg">
            <DialogTitle id="simple-dialog-title">Terms and Conditions</DialogTitle>
            <DialogContent>
                {terms !== null && <div dangerouslySetInnerHTML={{__html: terms}} />}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default TermsAndConditionsDialog;
